import { render, staticRenderFns } from "./mp3.vue?vue&type=template&id=25375331&scoped=true"
import script from "./mp3.vue?vue&type=script&lang=js"
export * from "./mp3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25375331",
  null
  
)

export default component.exports